import React, { useState } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    kind: "general",
  });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent. We'll reply within 24 hours.");
      setForm({ name: "", email: "", subject: "", message: "", kind: "general" });
    } catch {
      toast.error("Failed to send message");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <Nav />
      <div className="pt-32 pb-16 px-6 sm:px-10">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#a0a0a0] mb-4">Contact</div>
            <h1 className="text-4xl sm:text-5xl font-bold tracking-tighter" data-testid="contact-title">
              Talk to a human.
              <br />
              We reply within 24 hours.
            </h1>
            <p className="text-[#a0a0a0] mt-6 max-w-md leading-relaxed">
              Custom packages, enterprise pricing, large creator deals, or special editing
              requests — we'd love to hear about it.
            </p>
            <ul className="mt-10 space-y-3 text-sm text-[#a0a0a0]">
              <li>Email: hello@bliencer.io</li>
              <li>Live chat: On during business hours</li>
              <li>Phone: On enterprise plans</li>
            </ul>
          </div>

          <form
            onSubmit={submit}
            className="squircle-lg border border-[#2b2b2b] bg-[#111] p-8 space-y-4"
            data-testid="contact-form"
          >
            <select
              data-testid="contact-kind"
              value={form.kind}
              onChange={(e) => setForm({ ...form, kind: e.target.value })}
              className="w-full squircle-sm bg-transparent border border-[#2b2b2b] px-4 py-3 focus:border-white outline-none"
            >
              <option value="general">General inquiry</option>
              <option value="enterprise">Enterprise pricing</option>
              <option value="custom_package">Custom package</option>
              <option value="creator_deal">Large creator deal</option>
              <option value="support">Support</option>
            </select>
            <input
              data-testid="contact-name"
              required
              placeholder="Your name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full squircle-sm bg-transparent border border-[#2b2b2b] px-4 py-3 focus:border-white outline-none"
            />
            <input
              data-testid="contact-email"
              required
              type="email"
              placeholder="Your email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full squircle-sm bg-transparent border border-[#2b2b2b] px-4 py-3 focus:border-white outline-none"
            />
            <input
              data-testid="contact-subject"
              required
              placeholder="Subject"
              value={form.subject}
              onChange={(e) => setForm({ ...form, subject: e.target.value })}
              className="w-full squircle-sm bg-transparent border border-[#2b2b2b] px-4 py-3 focus:border-white outline-none"
            />
            <textarea
              data-testid="contact-message"
              required
              placeholder="Tell us what you need"
              rows={6}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="w-full squircle-sm bg-transparent border border-[#2b2b2b] px-4 py-3 focus:border-white outline-none"
            />
            <button
              data-testid="contact-submit"
              disabled={loading}
              type="submit"
              className="w-full squircle bg-white text-black py-3.5 font-medium hover:bg-[#f2f2f2] btn-anim inline-flex items-center justify-center gap-2 disabled:opacity-50"
            >
              {loading ? "Sending…" : "Send message"} <ArrowRight size={14} />
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
